import cjenik from '../images/cjenik-megaton.jpg';

export default function PriceList() {
  
    return (
      <div className='PriceList'>
        <a href="https://radiomegaton.hr/wp-content/uploads/2021/03/Cjenik-Megaton-01-01-20.pdf" target="_blank" rel="noreferrer">
          <span>PREUZMITE CJENIK</span>
        </a>
        <div><img src={cjenik} alt="cjenik"></img></div>
      </div>
    );
  }